(() => {
    const ADDON_PREFIX = 'addon_';
    const GIFT_PARAM = 'addon_gift';

    function initAddonDrawer(scope = document) {
        const productAddonsRoot = scope.querySelector('[data-product-addons]');
        if (!productAddonsRoot) return;
        if (productAddonsRoot.dataset.addonsInitialized === 'true') return;

        productAddonsRoot.dataset.addonsInitialized = 'true';

        const state = {};
        let giftActive = true;

        // Restore gift state from URL before first render
        try {
            const initialParams = new URLSearchParams(window.location.search);
            if (initialParams.get(GIFT_PARAM) === '0') {
                giftActive = false;
            }
        } catch (e) {
            console.warn('[addons] Could not read gift state from URL', e);
        }

        const parseMoneyToCents = (value) => {
            if (!value) return 0;
            const normalized = String(value).replace(/[^0-9.,-]/g, '').replace(',', '.');
            const amount = parseFloat(normalized);
            return Number.isNaN(amount) ? 0 : Math.round(amount * 100);
        };

        const formatMoneyFromCents = (cents) => {
            return `$${(cents / 100).toFixed(0)}`;
        };

        const updateURL = () => {
            try {
                const url = new URL(window.location.href);

                // Clear existing addon params
                [...url.searchParams.keys()]
                    .filter((k) => k.startsWith(ADDON_PREFIX))
                    .forEach((k) => url.searchParams.delete(k));

                // Set selected groups
                Object.keys(state).forEach((groupKey) => {
                    const items = state[groupKey];
                    if (items && items.length > 0) {
                        url.searchParams.set(
                            `${ADDON_PREFIX}${groupKey}`,
                            items.map((i) => i.variantId).join(',')
                        );
                    }
                });

                // Only write gift param when inactive (true is the default)
                if (!giftActive) {
                    url.searchParams.set(GIFT_PARAM, '0');
                }

                history.replaceState(history.state, '', url.toString());
            } catch (e) {
                console.warn('[addons] Could not update URL with addon state', e);
            }
        };

        const updateAddToCartTotal = () => {
            const atcPrices = document.querySelector('[data-atc-prices]');
            const atcPriceEl = document.querySelector('[data-atc-price]');
            const atcCompareEl = document.querySelector('[data-atc-compare]');

            if (!atcPrices || !atcPriceEl || !atcCompareEl) return;

            const basePrice = parseInt(atcPrices.dataset.basePrice || '0', 10);
            const baseCompare = parseInt(atcPrices.dataset.baseCompare || '0', 10);

            let selectedAddonsPrice = 0;
            let selectedAddonsCompare = 0;

            document.querySelectorAll('.product-addons__item--selected').forEach((item) => {
                selectedAddonsPrice += parseInt(item.dataset.selectedPrice || '0', 10);
                selectedAddonsCompare += parseInt(item.dataset.selectedComparePrice || '0', 10);
            });

            const giftEl = document.querySelector('[data-gift-product]');
            let giftPrice = 0;
            let giftCompare = 0;

            if (giftEl && giftEl.dataset.giftActive === 'true') {
                giftPrice = parseInt(giftEl.dataset.giftPrice || '0', 10) || 0;
                giftCompare = parseInt(giftEl.dataset.giftComparePrice || '0', 10) || 0;
            }

            const finalPrice = basePrice + selectedAddonsPrice + giftPrice;

            const finalCompare =
                Math.max(baseCompare, basePrice) +
                selectedAddonsCompare +
                giftCompare;

            atcPriceEl.textContent = formatMoneyFromCents(finalPrice);

            if (finalCompare > finalPrice) {
                atcCompareEl.textContent = formatMoneyFromCents(finalCompare);
                atcCompareEl.classList.remove('hide');
            } else {
                atcCompareEl.textContent = '';
                atcCompareEl.classList.add('hide');
            }
        };

        const syncAddonCartLines = () => {
            const container = scope.querySelector('[data-addon-cart-lines]');
            if (!container) return;

            const selectedCards = scope.querySelectorAll('[data-selected-variant-id]');
            const giftEl = scope.querySelector('[data-gift-product]');

            let html = '';

            if (giftEl && giftEl.dataset.giftVariantId && giftActive) {
                html += `<input type="hidden" name="gift_variant_id" value="${giftEl.dataset.giftVariantId}">`;
            }

            selectedCards.forEach((card) => {
                const variantId = card.dataset.selectedVariantId;
                if (!variantId) return;
                html += `<input type="hidden" name="addon_variant_ids[]" value="${variantId}">`;
            });

            container.innerHTML = html;
        };

        const renderGiftState = () => {
            const giftEl = scope.querySelector('[data-gift-product]');
            if (!giftEl) return;

            const toggle = giftEl.querySelector('[data-gift-toggle]');
            if (!toggle) return;

            giftEl.dataset.giftActive = giftActive ? 'true' : 'false';
            giftEl.classList.toggle('is-active', giftActive);
            giftEl.classList.toggle('is-inactive', !giftActive);

            toggle.classList.toggle('is-active', giftActive);
            toggle.classList.toggle('is-inactive', !giftActive);
            toggle.setAttribute('aria-pressed', giftActive ? 'true' : 'false');

            syncAddonCartLines();
            updateAddToCartTotal();
        };

        const bindGiftToggle = () => {
            const giftEl = scope.querySelector('[data-gift-product]');
            const giftToggle = scope.querySelector('[data-gift-toggle]');

            if (!giftEl || !giftToggle) return;

            const toggleGift = () => {
                giftActive = !giftActive;
                updateURL();
                renderGiftState();
            };

            if (giftToggle.dataset.bound !== 'true') {
                giftToggle.dataset.bound = 'true';

                giftToggle.addEventListener('click', (event) => {
                    event.stopPropagation();
                    toggleGift();
                });
            }

            if (giftEl.dataset.cardBound !== 'true') {
                giftEl.dataset.cardBound = 'true';

                giftEl.addEventListener('click', (event) => {
                    const clickedButton = event.target.closest('[data-gift-toggle]');

                    if (clickedButton) return;

                    toggleGift();
                });
            }
        };

        bindGiftToggle();
        renderGiftState();

        const drawer = scope.querySelector('[data-addon-drawer]');
        if (!drawer) return;
        if (drawer.dataset.drawerInitialized === 'true') return;

        drawer.dataset.drawerInitialized = 'true';

        const titleEl = drawer.querySelector('[data-addon-drawer-title]');
        const closeButtons = drawer.querySelectorAll('[data-addon-drawer-close]');
        const groups = drawer.querySelectorAll('[data-addon-group]');
        const panel = drawer.querySelector('.addon-drawer__panel');
        const overlay = drawer.querySelector('.addon-drawer__overlay');

        let isClosing = false;

        const isMobile = () => window.innerWidth <= 768;

        const applyFilter = (groupKey) => {
            groups.forEach((group) => {
                group.hidden = group.dataset.addonGroupKey !== groupKey;
            });
        };

        const lockScroll = () => {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

            document.documentElement.classList.add('addon-drawer-open');
            document.body.classList.add('addon-drawer-open');

            if (!isMobile() && scrollbarWidth > 0) {
                document.body.style.paddingRight = `${scrollbarWidth}px`;
            }
        };

        const unlockScroll = () => {
            document.documentElement.classList.remove('addon-drawer-open');
            document.body.classList.remove('addon-drawer-open');
            document.body.style.paddingRight = '';
        };

        const getSelectionsRoot = (groupKey) => {
            return scope.querySelector(`[data-addon-selections="${groupKey}"]`);
        };

        const getTrigger = (groupKey) => {
            return scope.querySelector(`.product-addons__item--trigger[data-addon-trigger="${groupKey}"]`);
        };

        const getGroupState = (groupKey) => {
            if (!Array.isArray(state[groupKey])) {
                state[groupKey] = [];
            }
            return state[groupKey];
        };

        const findInState = (groupKey, variantId) => {
            return getGroupState(groupKey).find((item) => item.variantId === variantId);
        };

        const removeFromState = (groupKey, variantId) => {
            state[groupKey] = getGroupState(groupKey).filter((item) => item.variantId !== variantId);
        };

        const addToState = (groupKey, payload) => {
            if (findInState(groupKey, payload.variantId)) return;
            getGroupState(groupKey).push(payload);
        };

        const updateTriggerVisibility = () => {
            const triggers = scope.querySelectorAll('.product-addons__item--trigger[data-addon-trigger]');

            triggers.forEach((trigger) => {
                const groupKey = trigger.dataset.addonTrigger;
                const hasSelections = getGroupState(groupKey).length > 0;
                trigger.style.display = hasSelections ? 'none' : '';
            });
        };

        const bindDynamicOpenButtons = (root = scope) => {
            const buttons = root.querySelectorAll('[data-addon-open-drawer]');

            buttons.forEach((button) => {
                if (button.dataset.drawerBound === 'true') return;

                button.dataset.drawerBound = 'true';

                button.addEventListener('click', () => {
                    const title = button.dataset.drawerTitle || 'Add-on';
                    const groupKey = button.dataset.addonGroupKey || '';

                    if (!groupKey) return;

                    if (titleEl) {
                        titleEl.textContent = title;
                    }

                    applyFilter(groupKey);
                    syncDrawerChecks(groupKey);

                    if (!drawer.hidden) return;

                    isClosing = false;
                    drawer.hidden = false;

                    if (panel) {
                        panel.getBoundingClientRect();
                    }

                    requestAnimationFrame(() => {
                        drawer.classList.add('is-open');
                    });

                    lockScroll();
                });
            });
        };

        const renderSelections = (groupKey) => {
            const root = getSelectionsRoot(groupKey);
            const trigger = getTrigger(groupKey);
            if (!root || !trigger) return;

            const items = getGroupState(groupKey);
            const triggerButton = trigger.querySelector('[data-addon-open-drawer]');
            const groupName = triggerButton?.dataset.addonGroupName || 'Add-on';

            if (!items.length) {
                root.innerHTML = '';
                updateTriggerVisibility();
                syncAddonCartLines();
                updateAddToCartTotal();
                return;
            }

            root.innerHTML = items
                .map(
                    (item) => `
                        <div
  class="product-addons__item product-addons__item--selected"
  data-selected-variant-id="${item.variantId}"
  data-selected-price="${item.priceCents || 0}"
  data-selected-compare-price="${item.comparePriceCents || 0}"
>
                            <div class="product-addons__media">
                                ${item.image ? `<img src="${item.image}" alt="${item.title}" class="product-addons__image">` : ''}
                            </div>

                            <div class="product-addons__content">
                                <p class="product-addons__name">
    <span>${item.groupName || groupName}</span>
    <span class="product-addons__price-title">
        <span class="product-addons__price">
            ${item.price}
        </span>
        ${item.groupCompareAtPrice ? `
            <span class="product-addons__compare-price">
                ${item.groupCompareAtPrice}
            </span>
        ` : ''}
    </span>
</p>
                                <p class="product-addons__desc">
                                    <span class="product-addons__desc-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.50085 0.213675C9.63751 0.350377 9.71428 0.535759 9.71428 0.729056C9.71428 0.922352 9.63751 1.10773 9.50085 1.24444L4.03699 6.7083C3.96479 6.78052 3.87906 6.83781 3.78471 6.8769C3.69036 6.91598 3.58923 6.9361 3.48711 6.9361C3.38498 6.9361 3.28386 6.91598 3.18951 6.8769C3.09516 6.83781 3.00943 6.78052 2.93722 6.7083L0.222545 3.9941C0.152922 3.92686 0.0973871 3.84642 0.0591826 3.75748C0.0209781 3.66855 0.000868619 3.57289 2.75234e-05 3.4761C-0.000813572 3.37931 0.0176306 3.28332 0.0542838 3.19373C0.090937 3.10414 0.145065 3.02275 0.21351 2.95431C0.281955 2.88586 0.363345 2.83173 0.452933 2.79508C0.54252 2.75843 0.638511 2.73998 0.735303 2.74082C0.832094 2.74167 0.92775 2.76178 1.01669 2.79998C1.10562 2.83818 1.18606 2.89372 1.25331 2.96334L3.48686 5.1969L8.46961 0.213675C8.5373 0.145935 8.61768 0.0921974 8.70616 0.0555341C8.79463 0.0188708 8.88946 0 8.98523 0C9.081 0 9.17583 0.0188708 9.2643 0.0555341C9.35277 0.0921974 9.43316 0.145935 9.50085 0.213675Z" fill="#0A301F"/>
                                        </svg>
                                    </span>
                                    <span class="product-addons__desc-title">${item.title}</span>
                                </p>
                            </div>

                            <div class="product-addons__actions">
                                <span class="product-addons__price-wrap">
        <span class="product-addons__price">
            ${item.price}
        </span>
        ${item.groupCompareAtPrice ? `
            <span class="product-addons__compare-price">
                ${item.groupCompareAtPrice}
            </span>
        ` : ''}
    </span>

                                <button
                                    type="button"
                                    class="product-addons__button"
                                    data-addon-open-drawer
                                    data-drawer-title="${item.groupName || groupName}"
                                    data-addon-group-key="${groupKey}"
                                    data-addon-group-name="${item.groupName || groupName}"
                                >
                                    Edit
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M0 14V10.6944L10.2667 0.447222C10.4222 0.30463 10.5941 0.194445 10.7823 0.116667C10.9706 0.038889 11.1681 0 11.375 0C11.5819 0 11.7828 0.038889 11.9778 0.116667C12.1727 0.194445 12.3413 0.311111 12.4833 0.466667L13.5528 1.55556C13.7083 1.69815 13.8219 1.86667 13.8934 2.06111C13.965 2.25556 14.0005 2.45 14 2.64444C14 2.85185 13.9645 3.04967 13.8934 3.23789C13.8224 3.42611 13.7088 3.59774 13.5528 3.75278L3.30555 14H0ZM11.3556 3.73333L12.4444 2.64444L11.3556 1.55556L10.2667 2.64444L11.3556 3.73333Z" fill="#0A301F"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    `
                )
                .join('');

            bindDynamicOpenButtons(root);
            updateTriggerVisibility();
            syncAddonCartLines();
            updateAddToCartTotal();
        };

        const syncDrawerChecks = (groupKey) => {
            const drawerItems = drawer.querySelectorAll('[data-addon-item]');

            drawerItems.forEach((itemEl) => {
                const checkbox = itemEl.querySelector('.addon-drawer__checkbox');
                if (!checkbox) return;
                if (itemEl.dataset.addonGroupKey !== groupKey) return;

                checkbox.checked = !!findInState(groupKey, itemEl.dataset.variantId);
            });
        };

        const bindDrawerItems = () => {
            const drawerItems = drawer.querySelectorAll('[data-addon-item]');

            drawerItems.forEach((itemEl) => {
                if (itemEl.dataset.bound === 'true') return;
                itemEl.dataset.bound = 'true';

                const checkbox = itemEl.querySelector('.addon-drawer__checkbox');
                if (!checkbox) return;

                checkbox.addEventListener('change', () => {
                    const groupKey = itemEl.dataset.addonGroupKey;

                    const payload = {
                        variantId: itemEl.dataset.variantId,
                        productId: itemEl.dataset.productId,
                        title: itemEl.dataset.title,
                        desc: itemEl.dataset.desc || 'Description',
                        image: itemEl.dataset.image,
                        groupName: itemEl.dataset.groupName || 'Add-on',

                        price: itemEl.dataset.metaobjectPrice || '',

                        groupCompareAtPrice: itemEl.dataset.actualPrice || '',
                        priceCents: parseInt(itemEl.dataset.priceCents || '0', 10) || parseMoneyToCents(itemEl.dataset.metaobjectPrice || ''),
                        comparePriceCents: parseInt(itemEl.dataset.comparePriceCents || '0', 10) || parseMoneyToCents(itemEl.dataset.actualPrice || ''),
                    };

                    if (checkbox.checked) {
                        addToState(groupKey, payload);
                    } else {
                        removeFromState(groupKey, payload.variantId);
                    }

                    updateURL();
                    renderSelections(groupKey);
                });
            });
        };

        const restoreFromURL = () => {
            try {
                const params = new URLSearchParams(window.location.search);

                params.forEach((value, key) => {
                    if (!key.startsWith(ADDON_PREFIX) || key === GIFT_PARAM) return;

                    const groupKey = key.slice(ADDON_PREFIX.length);
                    const variantIds = value.split(',').filter(Boolean);

                    variantIds.forEach((variantId) => {
                        try {
                            const itemEl = drawer.querySelector(
                                `[data-addon-item][data-variant-id="${variantId}"][data-addon-group-key="${groupKey}"]`
                            );
                            if (!itemEl) return;

                            const payload = {
                                variantId: itemEl.dataset.variantId,
                                productId: itemEl.dataset.productId,
                                title: itemEl.dataset.title,
                                desc: itemEl.dataset.desc || 'Description',
                                image: itemEl.dataset.image,
                                groupName: itemEl.dataset.groupName || 'Add-on',
                                price: itemEl.dataset.metaobjectPrice || '',
                                groupCompareAtPrice: itemEl.dataset.actualPrice || '',
                                priceCents: parseInt(itemEl.dataset.priceCents || '0', 10) || parseMoneyToCents(itemEl.dataset.metaobjectPrice || ''),
                                comparePriceCents: parseInt(itemEl.dataset.comparePriceCents || '0', 10) || parseMoneyToCents(itemEl.dataset.actualPrice || ''),
                            };

                            addToState(groupKey, payload);

                            const checkbox = itemEl.querySelector('.addon-drawer__checkbox');
                            if (checkbox) checkbox.checked = true;
                        } catch (e) {
                            console.warn(`[addons] Could not restore variant "${variantId}" in group "${groupKey}"`, e);
                        }
                    });
                });
            } catch (e) {
                console.warn('[addons] Could not restore addon state from URL', e);
            }
        };

        const closeDrawer = () => {
            if (drawer.hidden || isClosing) return;
            isClosing = true;

            drawer.classList.remove('is-open');
            unlockScroll();

            const finalizeClose = () => {
                drawer.hidden = true;
                isClosing = false;
                if (panel) {
                    panel.removeEventListener('transitionend', onPanelEnd);
                }
            };

            const onPanelEnd = (event) => {
                if (event.target !== panel) return;
                finalizeClose();
            };

            if (panel) {
                panel.addEventListener('transitionend', onPanelEnd);
            }

            setTimeout(finalizeClose, 420);
        };

        bindDynamicOpenButtons(scope);
        bindDrawerItems();
        restoreFromURL();
        updateTriggerVisibility();

        Object.keys(state).forEach((groupKey) => {
            renderSelections(groupKey);
        });

        updateAddToCartTotal();

        // Re-sync addon params after Shopify updates the URL for variant changes
        document.addEventListener('change', (event) => {
            if (event.target.matches('[data-variant-input]')) {
                setTimeout(updateURL, 0);
            }
        });

        closeButtons.forEach((button) => {
            if (button.dataset.bound === 'true') return;
            button.dataset.bound = 'true';
            button.addEventListener('click', closeDrawer);
        });

        if (overlay && overlay.dataset.bound !== 'true') {
            overlay.dataset.bound = 'true';
            overlay.addEventListener('click', closeDrawer);
        }

        if (drawer.dataset.escapeBound !== 'true') {
            drawer.dataset.escapeBound = 'true';

            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' && !drawer.hidden) {
                    closeDrawer();
                }
            });
        }

        if (drawer.dataset.resizeBound !== 'true') {
            drawer.dataset.resizeBound = 'true';

            window.addEventListener('resize', () => {
                if (!drawer.hidden && !isMobile()) {
                    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
                    document.body.style.paddingRight = scrollbarWidth > 0 ? `${scrollbarWidth}px` : '';
                }
            });
        }
    }

    document.addEventListener('DOMContentLoaded', () => initAddonDrawer(document));
    document.addEventListener('shopify:section:load', (event) => initAddonDrawer(event.target));
})();
